import clsx from 'clsx';

export const ProductStoreItemSkeleton = ({
  isOneTimeProduct,
  maxCard,
}: {
  isOneTimeProduct: boolean;
  maxCard: number;
}) => {
  return (
    <div className="grid grid-cols-1 @[406px]:grid-cols-2 @[746px]:grid-cols-4 gap-6 px-6 ">
      {Array(maxCard)
        .fill(null)
        .map((_, index) => (
          <div
            key={`card-${index}`}
            className="flex flex-col gap-3"
            style={{ flex: '1 0 130px' }}
          >
            {!isOneTimeProduct && (
              <div className="bg-[#EBECEF] h-[60px] rounded-lg order-1" />
            )}
            <div
              className={clsx('bg-[#C9CBCD] h-[32px] rounded-lg', {
                'order-3': isOneTimeProduct,
                'order-2': !isOneTimeProduct,
              })}
            />
            <div
              className={clsx('bg-[#EBECEF]  rounded-lg', {
                'order-2 h-[264px]': isOneTimeProduct,
                'order-3 h-[192px]': !isOneTimeProduct,
              })}
            />
          </div>
        ))}
    </div>
  );
};
